import { Stack, Image, IStackTokens, ImageFit } from '@fluentui/react';
import React, { useContext, useEffect, useState } from 'react';
import { TProduct, TSet } from '../constants/types';
import { NavLink } from 'react-router-dom';
import styles from '../styles/pokemon.module.scss';
import CarouselComponent from './carouselComponent';
import MainCarouselComponent, { TCarouselItem } from './mainCarouselComponent';
import GlobalContext from '../_contexts/GlobalContext';
import Footer from './footerComponent';

export interface IWelcomeComponentProps {
    UpdateStateExtern: Function;
    onSetSelectedSet: Function;
    ShowAlertCoachmarks: Function;
    Sets: TSet[];
    DoSearch: Function;
}

export interface IWelcomeComponentState {
    carouselItems: TCarouselItem[];
    maxIndex: number;
    sets: TSet[];
    cards: TProduct[];
};

const WelcomeComponent : React.FunctionComponent<IWelcomeComponentProps> = (props : IWelcomeComponentProps) => {
    const [cards, setcards] = useState<TProduct[]>([]);
    const [sets, setsets] = useState<TSet[]>(props.Sets);
    const [maxIndex, setmaxIndex] = useState<number>(12);
    const [carouselItems, setcarouselItems] = useState<TCarouselItem[]>([]);

    const { SetPageWidth, DebugEnabled, PageWidth, MainCarouselSets, DevEnabled, AnimationsEnabled, ShowFooter, SetShowFooter, GlobalImagesVersion } = useContext(GlobalContext);

    useEffect(() => {
        setcarouselItems(getCarouselItems(props.Sets));
        GetRareCards();
        
        window.onscroll = onScroll;
        window.onresize = OnResize;

        //Unmount code
        return () => {
            window.onscroll = null;
            window.onresize = null;
        }
    },[]);

    useEffect(() => {
        window.onscroll = onScroll;
    }, [maxIndex]);

    useEffect(() => {
        setcarouselItems(getCarouselItems(sets));
    },[PageWidth]);

    const getCarouselItems = (_sets: TSet[] = []) : TCarouselItem[] => {
        if (_sets.length === 0){
            _sets=props.Sets;
            setsets(_sets);
        }
        let carouselitems : TCarouselItem[] = [];
        let csets : TSet[] = [];
        MainCarouselSets?.forEach((setid:number) => {
            csets = csets.concat(_sets.filter(s => s.id === setid));
        });

        csets.forEach(set => {
            carouselitems.push({
                quickLinkImageUrl: process.env.PUBLIC_URL + `/assets/pokemon/${set.id.toString()}/${set.id}.webp`,
                quickLinkOnClick: () => { onSetSelectedSet(set.id); },
                content: <div onClick={() => { onSetSelectedSet(set.id); }} style={{cursor:"pointer"}}>                                                               
                            <div style={{width:PageWidth, backgroundImage:`url(${process.env.PUBLIC_URL}/assets/pokemon/${set.id.toString()}/logo.webp?v=${GlobalImagesVersion})`}} className={styles.mainSelectedSetLogo} /> 
                         </div>
                         
            });
        });
        return carouselitems;
    }

    const OnResize = () => {
        SetPageWidth(window.innerWidth-25 > 1232 ? 1232 : window.innerWidth);
    }

    const onScroll = () => {
        if ((window.innerHeight + window.scrollY) >= document.body.scrollHeight - 100) {
            setmaxIndex(maxIndex + 6);
        }
        if (maxIndex >= props.Sets.length) {
            SetShowFooter(true);
            window.onscroll = null;
        }
    }

    const onSetSelectedSet = (setId:number) => {
        props.UpdateStateExtern(["firstLoad","showFooter"],[false,true]).then(() => {
            props.onSetSelectedSet(setId);
        }).catch(err => {});
    }

    const GetRareCards = () => {
        let hostUrl = "https://pokemoncollectie.nl/Backend"
        if (DevEnabled) {
            hostUrl = "https://localhost:7254";
        }
    
        fetch(`${hostUrl}/GetRarecards?max=10`, {
            method: 'GET',
        }).then((response) => response.json()).then((data: TProduct[]) => {
            data.forEach(card=> {
                if (card.number > 99) {
                    card.scardnumber = `${card.number}`;
                } else if (card.number > 9) {
                    card.scardnumber = `0${card.number}`;
                } else {
                    card.scardnumber = `00${card.number}`;
                }
                card.uniqueSearchInSetString = `${card.scardnumber}/`;
                card.scardnumber += `/${card.size}`;
                if (card.size > 99) {
                    card.uniqueSearchInSetString += `${card.size}`;
                } else if (card.size > 9) {
                    card.uniqueSearchInSetString += `0${card.size}`;
                } else {
                    card.uniqueSearchInSetString += `00${card.size}`;
                }

                //TODO: move to backend, minimale prijs toevoegen
                card.set = sets.filter(set => set.id === card.setID)[0];
                card.priceInUSD = Math.round(card.priceInUSD * 100) /100;
                card.scost = `${card.cost}`;
                let imageUrls: string[] = [];
                card.imageNames?.split(',').forEach(imageName => {
                    imageUrls.push(`${process.env.PUBLIC_URL}/assets/pokemon/${card.setID}/${card.number.toString()}/${imageName}?v=1`);
                });
                imageUrls.push(`${process.env.PUBLIC_URL}/assets/pokemon/cardback.webp`);
                card.imageUrls = imageUrls;
            });
            setcards(data);
        });
    }

    return (
        <div>
            {DebugEnabled && <div>Outer: {window.outerWidth} - {window.outerHeight} Inner: {window.innerWidth} - {window.innerHeight}</div>}
            <div className={styles.mainSection} >
                <Stack horizontalAlign='center'>
                    <div style={{maxWidth: PageWidth, overflow:"hidden"}}>
                        {carouselItems.length && <MainCarouselComponent isDev={DevEnabled} switchSpeed={20} animationsEnabled={AnimationsEnabled} items={carouselItems} maxWidth={PageWidth} />}
                        <div style={{maxWidth: PageWidth-10, overflow:"hidden"}}>
                            <CarouselComponent animationsEnabled={false} isDev={DevEnabled} />
                        </div>
                    </div>
                    <Stack horizontal style={{maxWidth:"100%",overflow:"hidden",marginBottom:8}}>
                        {cards.map((card,index) => {
                            if ((PageWidth > 960 && (200*(1+index) < PageWidth)) || 
                                (PageWidth <= 960 && (80*(index+1) < PageWidth))){
                                const r = Math.floor(Math.random() * 4);
                                let shimmerStyle = styles[`cardshimmer${r}`];
                                return <NavLink to={`/Pokemon Kaart/${card.set.name} - ${card.title} - ${card.scardnumber} - ${card.version}`} onClick={ ()=>{ props.UpdateStateExtern(["firstLoad"],[false]); }}>
                                            <Stack verticalAlign='center' horizontalAlign='center' style={{overflow:"hidden", paddingLeft:10}}>
                                                <div className={`${styles.cardshine} ${styles.cardCompImgMain}`}>
                                                    <Image {...{imageFit: ImageFit.centerContain,
                                                                className: styles.cardCompImgMain,
                                                                src: card?.imageUrls?.length && card.imageUrls[0],
                                                                onError: ( e ) => { e.currentTarget.onerror = null; 
                                                                                    e.currentTarget.src=`${process.env.PUBLIC_URL}/assets/NoImgFound.webp`},
                                                                styles: props => ({ root: { margin: 0, cursor: "pointer", backgroundColor: "transparent" } }),
                                                            }} alt="" />
                                                    <div className={shimmerStyle}></div>
                                                </div>
                                            </Stack>
                                        </NavLink>
                                        
                            }
                        })}
                    </Stack>
                    <div style={{maxWidth: PageWidth, overflow:"hidden",width:"100%"}}>
                        {sets.map((set,index) => {
                            if (index < maxIndex && set.size > 0) {
                                return  <div onClick={() => { onSetSelectedSet(set.id); }} 
                                                    style={{position:"relative", float:"left"}}>
                                                <Image style={{ maxWidth:(PageWidth/3)-18,
                                                                minWidth:(PageWidth/3)-18,
                                                                minHeight:(PageWidth/4),
                                                                maxHeight:(PageWidth/4),
                                                                position:"relative",
                                                                width:"100%"}} 
                                                        className={`${styles.cPanel} ${styles.setLogoMenuWelcome}`} src={process.env.PUBLIC_URL + `/assets/pokemon/${set.id.toString()}/${set.id.toString()}.webp`} 
                                                        alt={set.name} />    
                                                {(set.cardcount === undefined || set.cardcount === 0) && <Image {...{imageFit: ImageFit.centerContain,
                                                            className: styles.soldOut,
                                                            src: process.env.PUBLIC_URL + `/assets/soldout.webp`,
                                                            styles: props => ({ root: { right:0, margin: 0, zIndex: 1} }),
                                                        }} alt="" />}    
                                                {DebugEnabled && <div>{set.id}</div>}                                            
                                            </div>
                                        
                                }
                            }
                        )}
                    </div>
                    {ShowFooter ? <Footer /> : <div>Meer sets aan het laden...</div>}
                </Stack>
            </div>
        </div>
    );
}

export default WelcomeComponent;